import React from "react";
import classNames from "classnames";
import { FastField } from "formik";
import { isFunction } from "lodash";

const validateField = (value) => {
  let error;
  if (!value) {
    error = "Please select any option.";
  }
  return error;
};

const Radio = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  className,
  checked,
  error,
  submitCount,
  touched,
  validate,
  ...props
}) => {
  const classes = classNames(
    {
      "is-invalid": error && (touched || !!submitCount),
      error: error && (touched || !!submitCount),
    },
    className
  );

  return (
    <div className={classes}>
      <FastField
        name={name}
        id={id || `${name}-${value}`}
        type="radio"
        value={value} // could be something else for output?
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        validate={validate && (isFunction(validate) ? validate : validateField)}
        className={"custom-control-input"}
      />
      <label className="custom-control-label" htmlFor={id || `${name}-${value}`}>
        {label}
      </label>
    </div>
  );
};

export default Radio;
